/* esm.sh - bech32@2.0.0 */
export * from "/*bech32@2.0.0/esnext/bech32.mjs";
export { default } from "/*bech32@2.0.0/esnext/bech32.mjs";
